import { connect } from 'react-redux'
import { Component, autobind } from "macguffin"
import { findTexture, Stage } from 'mc_pixi-fiber'
import { Sprite } from 'react-pixi-fiber'

import { Tween, Easing } from "@tweenjs/tween.js"

import { setRocketTakeoffComplete } from "game/redux/actions"
import GameMode from "game/modes"
import GameModeGroup from "game/modes/GameModeGroup"
import Rocket from "./Rocket"

import Timings from "game/Timings"

const {
	TAKEOFF_DELAY,
	TAKEOFF_DURATION,
	LEAVE_ATMOSPHERE_DURATION,
	ENTER_ORBIT_DURATION,
	TAKEOFF_COMPLETE_DELAY
} = Timings

const { floor } = Math
const GANTRY_SCALE = 0.7
const COOLANT_TRIGGER_COUNT = 4
const earthHiddenGroup = new GameModeGroup([GameMode.PICK, GameMode.FREESPIN, GameMode.MARS_INTRO])
const prepareRocketGroup = new GameModeGroup([GameMode.MAIN, GameMode.RESPIN])
const spaceGroup = new GameModeGroup([GameMode.FREESPIN, GameMode.MARS_INTRO])

@connect(state => ({
	refresh: state.game.refresh,
	currentGameMode: state.game.currentGameMode,
	currentPickStageIndex: state.game.currentPickStageIndex,
	currentFreespins: state.game.currentFreespins,
	reelStoppedIndex: state.game.reelStoppedIndex,
	freespinSummary: state.game.freespinSummary,
	globalPaused: state.base.paused,
	country: state.session.country
}), {
	setRocketTakeoffComplete
})
export default class RocketGroup extends Component {

	constructor() {
		super()
		const gantryTexture = findTexture("rocket/rocketbase")
		this.state = { gantryTexture }
	}

	componentWillMount() {
		const { props: {currentGameMode}} = this
		const isAnimating = earthHiddenGroup.contains(currentGameMode)
		const isLaunched = isAnimating
		const isInSpace = spaceGroup.contains(currentGameMode)

		const callback = (currentGameMode === GameMode.MARS_INTRO) ? this.marsSequence : undefined

		this.setState({
			isAnimating,
			isInSpace,
			isLaunched
		}, callback)
	}

	componentWillReceiveProps(nextProps) {
		const currentProps = this.props

		if (nextProps.currentGameMode !== currentProps.currentGameMode) {
			switch (nextProps.currentGameMode) {
				case GameMode.BONUS_COUNTDOWN:
					this.setState({ isAnimating: true })
					break
				case GameMode.BONUS_INTRO:
					this.setState({isAnimating: true, isLaunched: true})
					break
				case GameMode.MAIN:
					this.setState({isInSpace: false, isLaunched: false})
					break
				case GameMode.PICK:
					const isInSpace = !!nextProps.currentPickStageIndex
					this.setState({isInSpace, isAnimating: true, isLaunched: true})
					break
				case GameMode.FREESPIN:
					this.setState({isInSpace: true, isAnimating: true, isLaunched: true})
					break
				case GameMode.MARS_INTRO:
					this.setState({ isInSpace: true, isAnimating: true, isLaunched: true})
					this.marsSequence()
					break
			}
		}

		if (nextProps.currentFreespins !== currentProps.currentFreespins) {
			if (prepareRocketGroup.contains(nextProps.currentGameMode) && nextProps.currentFreespins >= COOLANT_TRIGGER_COUNT) {
				this.setState({isAnimating: true})
				if (this.rocket) {
					this.rocket.startCoolant()
				}
			} else {
				if (this.rocket) {
					this.rocket.stopCoolant(() => { this.pauseRendering() })
				}
			}
		}
	}

	componentWillUpdate(nextProps, nextState) {
		const currentState = this.state

		if (!earthHiddenGroup.contains(nextProps.currentGameMode)) {
			if (nextState.isLaunched && nextState.isLaunched !== currentState.isLaunched) {
				this.startLaunchSequence()
			}
		}

		if (nextState.isInSpace && nextState.isInSpace !== currentState.isInSpace) {
			this.rocket.leaveAtmosphere()
		}

		if (!nextState.isLaunched && nextState.isLaunched !== currentState.isLaunched) {
			this.rocket.resetToLaunchPositions()
		}
	}

	marsSequence = () => {
		new Tween()
		.to({}, 12000)
		.onComplete(() => {
			this.setState({ isInSpace: false, isAnimating: false, isLaunched: false})
		})
		.start()
	}

	pauseRendering = () => {
		if (!this.state.isLaunched) {
			this.setState({isAnimating: false})
		}
	}

	startLaunchSequence() {
		const { gantry, rocket } = this

		rocket.launch()

		const takeoffTween = new Tween(gantry.position)
			.delay(TAKEOFF_DELAY)
			.to({y: gantry.height * 1.5}, TAKEOFF_DURATION * 0.85)
			.easing(Easing.Exponential.In)
			.onComplete(() => {
				this.endLaunchSequence()
			})
			.start()
	}

	endLaunchSequence() {
		const tween = new Tween({})
			.delay(TAKEOFF_COMPLETE_DELAY)
			.onComplete(() => {
				this.props.setRocketTakeoffComplete()
			})
			.start()
	}

	render() {
		const { props, state } = this
		const { refresh, width, height, resolution, currentPickStageIndex, globalPaused, country } = props
		const { gantryTexture, isAnimating, isInSpace } = state || {}

		const gantryRatio = gantryTexture.orig.width / gantryTexture.orig.height
		const gantryHeight = height * GANTRY_SCALE
		const gantryWidth = floor(gantryHeight * gantryRatio)

		const showGantry = isNaN(currentPickStageIndex) && !isInSpace

		return (
			<div id="rocketContainer" className="rocketContainer">
				<Stage
					key = "rocketCanvas"
					name = "rocketCanvas"
					style = {{ width, height }}
					{...{
						resolution: resolution,
						width: width,
						height: height,
						paused: globalPaused || !isAnimating,
						options: {
							transparent: true,
							backgroundColor: 0x000000,
							antialias: true,
						  }
					}}
					
					>
					{ showGantry && <Sprite
						ref = {(gantry) => this.gantry = gantry}
						texture = {gantryTexture}
						x = {gantryWidth * -0.39}
						y = {gantryHeight * 0.2}
						width = {gantryWidth}
						height = {gantryHeight}
					/> }
					<Rocket
						key = "rocket"
						ref = {(rocket) => {this.rocket = rocket}}
						x = {gantryWidth * 0.28}
						y = {gantryHeight * 0.095}
						width = {gantryWidth}
						height = {gantryHeight}
						stageWidth = {width}
						stageHeight = {height}
						resolution = {resolution}
						currentPickStageIndex = {currentPickStageIndex}
						refresh = {refresh}
						country = {country && country.toLowerCase()}
					/>
				</Stage>
			</div>
		)
	}
}

